import {Matcher} from '@/lib/axiosAddTransforms'
import {
  payResponse, propertyResponse, dashDateResponse, payDateResponse
} from '@/transformers/utils'

const matchers: Matcher[] = [
  {
    test: /^\/invoices\/issued?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.params.status = payload.params.status.join(',')
        payload.url = `/bizs/${bizId}/transactions/`
        delete payload.data.bizId
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return {}
        }
        return {
          results: data.results.map((result) => invoiceListResponse(result)),
          ...propertyResponse(data),
        }
      },
    },
  },
  {
    test: /^\/invoices\/issued\/\$id\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId, id} = payload.params
        payload.url = `/bizs/${bizId}/transactions/${id}`
        delete payload.params.bizId
        delete payload.params.id
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return invoiceResponse(data)
      },
    },
  },
  {
    test: /^\/invoice-review\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId, invoiceId} = payload.params
        payload.url = `/bizs/${bizId}/transactions/${invoiceId}/invoice-review`
        delete payload.params.bizId
        delete payload.params.invoiceId
        return payload
      },
      response: (data) => {
        if(!data) {
          return {}
        }
        return data
      },
    },
  },
  {
    test: /^\/invoice-review\/download\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId, invoiceId} = payload.params
        payload.url = `/bizs/${bizId}/transactions/${invoiceId}/invoice-review/download`
        delete payload.params.bizId
        delete payload.params.invoiceId
        return payload
      },
      response: (data) => {
        if(!data) {
          return {}
        }
        return data
      },
    },
  },
]

export const invoiceListResponse = (data) => {
  const {
    id, status, errorCode, isForcedPayment, rawDataClientName, evidenceKind = '',
    sharedData = {},
    client = {representative: {}},
  } = data

  return {
    id: String(id),
    status: statusResponse(status),
    totalAmount: payResponse(sharedData.amountTotal),
    mainItemName: sharedData.mainItemName,
    errorMessage: errorCode,
    isForcedPayment,
    rawDataClientName,
    isTaxFree: evidenceKind === '매출_계산서',
    clientBizNumber: client.bizRegistrationNumber,
    clientId: String(client.id),
    tradedAt: dashDateResponse(sharedData.tradedAt),
  }
}

export const invoiceResponse = (data) => {
  const {
    id, status, errorCode, isForcedPayment,
    sharedData = {},
    virtualEvidences = [],
  } = data

  const {rawData, kind} = virtualEvidences[0] || {}
  const {amount, receiver, sender, detail} = rawData || {}
  return {
    id: String(id),
    status: statusResponse(status),
    errorCode,
    isForcedPayment,
    confirmNumber: rawData.ntsConfirmNumber,

    mainItemName: sharedData.mainItemName,
    totalAmount: payResponse(amount.totalAmount),
    totalSupply: payResponse(amount.supplyCostTotal),
    totalTax: payResponse(amount.taxTotal),
    isTaxFree: kind === '매출_계산서',

    writeDate: payDateResponse(rawData.writeDate),
    issueDate: payDateResponse(rawData.issueDate),
    sendDate: payDateResponse(rawData.sendDate),
    issueType: rawData.issueType,
    purposeType: rawData.purposeType,
    cash: payResponse(rawData.cash),
    checkBill: payResponse(rawData.checkBill),
    credit: payResponse(rawData.credit),
    note: payResponse(rawData.note),
    remark: rawData.remark,

    bizName: sender.name,
    bizOwnerName: sender.representativeName,
    bizAddress: sender.fullAddress,
    bizClass: sender.businessClass,
    bizType: sender.businessType,
    bizEmail: sender.email,
    bizNumber: sender.registrationNumber,
    bizTaxNumber: sender.taxRegistrationNumber,

    clientId: String(receiver.id),
    clientName: receiver.name,
    clientOwnerName: receiver.bossName,
    clientAddress: receiver.fullAddress,
    clientBizClass: receiver.businessClass,
    clientBizType: receiver.businessType,
    clientType: receiver.clientType,
    clientEmail: receiver.email,
    clientSubEmail: receiver.emailSub,
    clientBizNumber: receiver.bizRegistrationNumber,
    clientTaxNumber: receiver.taxRegistrationNumber,

    items: detail.map((item) => itemResponse(item)),
  }
}

const itemResponse = (item) => {
  return {
    ...item,
    purchaseDate: payDateResponse(item.purchaseDate),
    qty: Number(item.qty),
    supplyCost: payResponse(item.supplyCost),
    tax: payResponse(item.tax),
    unitCost: payResponse(item.unitCost),
  }
}

export const statusResponse = (status) => {
  // make processing status to completed status
  if(status === 'processing') {
    return 'completed'
  }
  return status
}

export default matchers
